// 3rd party
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

// components
import { LayoutMainNavComponent } from './layout-main-nav/layout-main-nav.component';
import { LayoutMainComponent } from './layout-main/layout-main.component';

// modules
import { InstrumentsModule } from 'app/instruments/instruments.module';
import { CalibrationsModule } from 'app/calibrations/calibrations.module';
import { MaterialModule } from 'app/shared/material/material.module';

// services
import { LayoutMainService } from './layout-main/shared/layout-main.service';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    RouterModule,
    MaterialModule,
    InstrumentsModule,
    CalibrationsModule,
    TranslateModule
  ],
  exports: [
    LayoutMainNavComponent,
    LayoutMainComponent,
  ],
  declarations: [
    LayoutMainNavComponent,
    LayoutMainComponent,
  ],
  providers: [
    LayoutMainService,
  ]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// ./src/app/shared/layout/layout.module.ts